(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // <header-drawer> custom HTML Element
  class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('header-drawer', HeaderDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-header"] && !Shopify.designMode) return;
  try {
    
  // <content-marquee> custom HTML Element
  class ContentMarquee extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('content-marquee', ContentMarquee);

  } catch(e) { console.error(e); }
})();
})();
